export type UserErrorResponse = 'fail' | 'retry';

export enum ServiceErrorType {
  system = 'system',
  network = 'network',
  rateLimit = 'rateLimit',
}

export enum UserResponseOptions {
  none = 0,
  retry = 1 << 1,
  fail = 1 << 2,
  all = ~(~0 << 4),
}

export type NotifyUserRequest = {
  errorType: ServiceErrorType;
  options?: UserResponseOptions;
};

export interface ServiceError {
  notifyUser(errorType: ServiceErrorType, options: UserResponseOptions): Promise<UserErrorResponse>;
}
